import {
  type GeographyQueries,
  defGeographyQueries,
} from '@kizen/query/geography';
import AxiosService from '__services/AxiosService';

const queries: GeographyQueries = defGeographyQueries(AxiosService);

export const countriesQuery: GeographyQueries['countriesQuery'] =
  queries.countriesQuery;
